import React from 'react';

import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import InboxRoundedIcon from '@mui/icons-material/InboxRounded';

import { StatePanel } from 'shared-components/state-views/state-panel';

interface PublicStateBaseProps {
  headingLevel?: 1 | 2;
  message: string;
  focusOnMount?: boolean;
}

interface PublicEmptyStateProps extends PublicStateBaseProps {
  heading?: string;
  icon?: React.ReactNode;
}

export const PublicEmptyState: React.FC<PublicEmptyStateProps> = ({
  icon = <InboxRoundedIcon />,
  ...rest
}) => <StatePanel {...rest} icon={icon} tone="neutral" />;

interface PublicErrorStateProps extends PublicStateBaseProps {
  action?: React.ReactNode;
  heading: string;
  icon?: React.ReactNode;
}

export const PublicErrorState: React.FC<PublicErrorStateProps> = ({
  icon = <ErrorOutlineRoundedIcon />,
  ...rest
}) => <StatePanel {...rest} icon={icon} tone="error" />;
